import type { CreditBalance } from '@src/domain/credits/entities/credit-balance.entity';
import type { CreditBalanceRepository } from '@src/domain/credits/repository/credit-balance.repository';
import apiClient from '../api/client';

interface CreditBalanceResponse {
    account_id: string;
    user_id: string;
    balance: {
        remaining_credits: number;
        total_credits: number;
        used_credits: number;
        usage_percentage: number;
    };
    current_period_start: string;
    current_period_end: string;
    is_active: boolean;
}

export class CreditBalanceRepositoryImpl implements CreditBalanceRepository {
    async getCreditBalance(): Promise<CreditBalance> {
        const response = await apiClient.get<CreditBalanceResponse>('/credits/balance');

        return {
            accountId: response.account_id,
            userId: response.user_id,
            balance: {
                remainingCredits: response.balance.remaining_credits,
                totalCredits: response.balance.total_credits,
                usedCredits: response.balance.used_credits,
                usagePercentage: response.balance.usage_percentage,
            },
            currentPeriodStart: response.current_period_start,
            currentPeriodEnd: response.current_period_end,
            isActive: response.is_active,
        };
    }
}

export const creditBalanceRepository = new CreditBalanceRepositoryImpl();
